<footer>
  <div class="navigation">
    <img class="logo" src="./assets/images/workflow.svg" alt="WorkFlow" />
    <div class="label-btn" routerLink="/how-to-guide">
      <img src="../../../../../assets/images/landing/how-to.webp" alt="How To Guide" width="21" height="21" />
      {{ 'general.how_to_guide' | translate }}
    </div>
    <div class="label-btn" routerLink="/contacts">
      <img src="../../../../../assets/images/landing/contacts.png" alt="Contacts" width="21" height="21" />
      {{ 'general.contacts' | translate }}
    </div>
  </div>
  <div class="links">
    <a class="link" routerLink="/privacy-policy">{{ 'general.privacy_policy_link' | translate }}</a>
    <a class="link" href="javascript: Cookiebot.renew()">{{ 'general.cookie_settings' | translate }}</a>
    <a class="link" routerLink="/cookie-policy">{{ 'general.cookie_link' | translate }}</a>
    <a class="link" routerLink="/terms-and-conditions">{{ 'general.terms_link' | translate }}</a>
    <div class="developed">{{ 'general.developed_by' | translate }} <a href="https://www.theraven.tech/" target="_blank">TheRaven</a></div>
  </div>
</footer>
